<script lang="ts">
  import { onMount, onDestroy } from "svelte"
  import type { Chart as ChartInstance } from "chart.js"

  let { data = { labels: [], values: [] }, kind = "bar" }: { data: { labels: string[]; values: number[] }; kind: "bar" | "line" } = $props()

  let canvas: HTMLCanvasElement | undefined = $state()
  let chart: ChartInstance | null = null

  onMount(async () => {
    if (!canvas) return
    const { Chart, registerables } = await import("chart.js")
    Chart.register(...registerables)

    chart = new Chart(canvas, {
      type: kind,
      data: {
        labels: data.labels,
        datasets: [{
          data: data.values,
          backgroundColor: "#3E6AE1",
          borderRadius: 4,
          maxBarThickness: 32
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false }
        },
        scales: {
          x: {
            ticks: { color: "#5C5E62", font: { size: 11 } },
            grid: { display: false }
          },
          y: {
            ticks: { color: "#5C5E62", font: { size: 11 } },
            grid: { color: "#EEEEEE" }
          }
        }
      }
    })
  })

  onDestroy(() => {
    chart?.destroy()
    chart = null
  })
</script>

<div class="relative" style="height: 220px;">
  {#if data.labels.length > 0}
    <canvas bind:this={canvas} aria-label="사용량 차트"></canvas>
  {:else}
    <div class="flex h-full items-center justify-center gate-panel gate-muted">
      아직 표시할 사용량이 없습니다.
    </div>
  {/if}
</div>
